import {initYaMap} from "../components/yamap";

export function initStewardLanding() {
    if ($('#steward_map').length) {
        const mapCenter = [53.207030, 50.223421];
        const placemarks = [
            {
                x: 53.207030,
                y: 50.223425,
                iconSize: [50, 53],
                iconUrl: '../img/icons/ks-placemark.svg'
            },
        ];
        initYaMap($('#steward_map'), mapCenter, placemarks);
    }


}

